import React from 'react';

import { Button, Card, CardHeader, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { navigateTo, requestResetPasswrod, setSuccess } from '../../redux/actions';
import { baseStyles } from '../../theme/style';
import { Loading } from '../common';
import Alerts from '../common/Alerts';

class Forgot extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      isButtonEnabled: true,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleResetRequest = this.handleResetRequest.bind(this);
    this.navigateToReset = this.navigateToReset.bind(this);
    this.navigateToBack = this.navigateToBack.bind(this);
    this.disableButton = this.disableButton.bind(this);
  }

  componentDidMount() {
    const headerStr = this.props.history.location.search;
    if (headerStr) {
      const data = headerStr.split('?')[1];
      const email = data.split('=')[1];
      console.log(data, email);
      if (!email) this.setState({ isButtonEnabled: false });
      this.setState({ email });
    }
  }

  componentWillUnmount() {
    this.props.setSuccess('');
  }
  handleChange({ name, value }) {
    this.setState({ [name]: value });
  }

  navigateToReset(data) {
    this.setState({ isButtonEnabled: true });
    this.props.navigateTo(`/reset-password?token=${data}`);
  }
  navigateToBack() {
    this.setState({ isButtonEnabled: true });
    this.props.history.goBack();
  }

  disableButton() {
    this.setState({ isButtonEnabled: true });
  }

  stopLoading() {
    this.setState({});
  }
  handleResetRequest() {
    if (!this.state.isButtonEnabled) return;
    this.setState({ isButtonEnabled: false });
    this.props.requestResetPasswrod(
      this.state.email,
      () => {
        this.setState({ isButtonEnabled: true });
      },
      this.disableButton,
    );
    // this.props.requestResetPasswrod(this.state.email,this.navigateToReset,this.disableButton);
  }

  getStyle() {
    return this.state.isButtonEnabled ? styles.buttonEnable : styles.buttonDisable;
  }
  render() {
    let errorMsg = '';
    let errorText = '';
    console.log('buttonEnable :' + this.state.isButtonEnabled);
    return (
      <div style={baseStyles.container}>
        <Card style={baseStyles.loginBox}>
          <CardHeader title="Reset Password" />

          <div style={baseStyles.form}>
            <TextField
              className="login-field"
              placeholder="Email"
              name="email"
              fullWidth={true}
              // errorText={errorText}
              onChange={(e) => this.handleChange(e.target)}
              value={this.state.email}
            />
            <Button label="Send Reset Link" style={this.getStyle()} onClick={this.handleResetRequest}>
              send an email
            </Button>
          </div>
          {!this.state.isButtonEnabled && <Loading />}
          <Alerts />
        </Card>
      </div>
    );
    /*return (
      <div style={baseStyles.container} >
        <Card style={baseStyles.loginBox}>
          <div>An email has been sent to you with a link to reset your password.</div>
        </Card>
      </div>
    );*/
  }
}
const styles = {
  error: {
    fontWeight: 'bold',
    color: '#f7183a',
  },
  success: {
    fontWeight: 'bold',
    color: '#4CAF50',
  },
  buttonDisable: {
    backgroundColor: 'gray',
  },
  buttonEnable: {
    backgroundColor: 'green',
  },
};
Forgot.propTypes = {
  passwordReset: PropTypes.func,
  user: PropTypes.object,
  email: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    login: state.login,
    user: state.user,
    message: state.message,
  };
}
const mapDispatchToProps = {
  requestResetPasswrod,
  navigateTo,
  setSuccess,
};

export default connect(mapStateToProps, mapDispatchToProps)(Forgot);
